<template>
  <div class="solution">
    <div class="solution1">
      <img :src="require(is1920 ? '../assets/solution1.png' : '../assets/solution28801.png')"/>
      <div class="desc">
        <p>智慧充电<span>云</span>平台</p>
        <p>互联互通，创造智能充电云时代</p>
      </div>
    </div>
    <div class="solution2">
      <div class="desc">
        <p>国恒充电<span>APP</span></p>
        <p>新能源汽车充电助手，集充电，预约、支付等功能，让充电随手可得，简单方便</p>
      </div>
      <div class="desc1">
        <div class="saoma">
          <img :src="require('../assets/saoma.png')"/>
          <div class="hd">扫码充电</div>
          <div>扫描充电桩上二维码，</div>
          <div>开启充电之旅</div>
        </div>
        <div class="yuyue">
          <img :src="require('../assets/yuyue.png')"/>
          <div class="hd">智能预约</div>
          <div>预约低谷电价，</div>
          <div>省钱省心</div>
        </div>
        <div class="zhifu">
          <img :src="require('../assets/zhifu.png')"/>
          <div class="hd">快捷支付</div>
          <div>绑定支付宝，微信支付，</div>
          <div>简单放心</div>
        </div>
      </div>
      <div class="bg">
        <img :src="require(is1920 ? '../assets/solution2.png' : '../assets/solution28802.png')"/>
      </div>
    </div>
    <div class="solution3">
      <img :src="require(is1920 ? '../assets/solution3.png' : '../assets/solution28803.png')"/>
      <div class="desc">
        <p>系统部署方案</p>
        <p>在云端部署智慧充电云平台，降低本地部署成本；在变压器低压侧增加智能电表，减少对现有电力的改造成本。智慧充电云平台支持对变压器、充电桩</p>
        <p>的负载数据进行实时分析，自动根据居民用电峰谷情况，调节充电桩的输出功率，实现居民用电优先。</p>
      </div>
    </div>
    <div class="solution4">
      <p class="title">电力部署方案</p>
      <p class="title1">利用小区现有供电容量，从小区变压器布线至停车场配电箱，根据业主的充电需求，就近从配电箱布线至停车位，并安装充电盒。</p>
      <div class="prompt">
        <div class="fugai">
          <img :src="require('../assets/fugai.png')"/>
          <div class="hd">整体覆盖</div>
          <div>均匀布线，停车场全覆盖，满足</div>
          <div>所有车位报装需求</div>
        </div>
        <div class="anzhuang">
          <img :src="require('../assets/anzhuang.png')"/>
          <div class="hd">按需安装</div>
          <div>根据业主需求，从离业主车位</div>
          <div>最近的配电箱接线安装</div>
        </div>
        <div class="jiyong">
          <img :src="require('../assets/jiyong.png')"/>
          <div class="hd">即装即用</div>
          <div>业主当天申请、当天安装、当天使用</div>
        </div>
        <div class="guanli">
          <img :src="require('../assets/guanli.png')"/>
          <div class="hd">集中管理</div>
          <div>云平台集中管控、实现充电设</div>
          <div>备统一管理，保障充电安全</div>
        </div>
      </div>
      <img class="bg" :src="require(is1920 ? '../assets/solution4.png' : '../assets/solution28804.png')"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'solution',
  inject: ['is1920']
}
</script>
<style lang="less">
.solution{
  width: 100%;
  p{
    margin: 0;
  }
  >div{
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .solution1{
    height: 9rem;
    .desc{
      position: absolute;
      top: .8rem;
      width: 100%;
      p{
        color: #292929;
        &:nth-child(1){
          font-size: .44rem;
          line-height: .62rem;
          span{
            color: #78D7D1;
          }
          margin-bottom: .15rem;
        }
        &:nth-child(2){
          font-size: .24rem;
          line-height: .33rem;
        }
      }
    }
  }
  .solution2{
    height: 9.06rem;
    background-color: white;
    >div{
      position: absolute;
    }
    .desc{
      width: 100%;
      top: 1.09rem;
      p{
        &:nth-child(1){
          font-size: .44rem;
          color: #292929;
          line-height: .62rem;
          margin-bottom: .14rem;
          span{
            color: #78D7D1;
          }
        }
        &:nth-child(2){
          font-size: .18rem;
          color: #717171;
          line-height: .35rem;
        }
      }
    }
    .desc1{
      top: 4.14rem;
      left: 3.6rem;
      display: flex;
      >div{
        text-align: center;
        font-size: .18rem;
        color: #717171;
        line-height: .25rem;
        .hd{
          font-size: .20rem;
          color: #333;
          line-height: .28rem;
        }
        img{
          margin-bottom: .27rem;
          width: .5rem;
          height: .5rem;
        }
      }
      .saoma{
        width: 1.82rem;
        margin-right: .46rem;
      }
      .yuyue{
        width: 1.28rem;
        margin-right: .37rem;
      }
      .zhifu{
        width: 2rem;
      }
    }
    .bg{
      top: 3.39rem;
      left: 8.67rem;
      width: 8.35rem;
      height: 7.49rem;
      text-align: center;
      z-index: 10;
      img{
        width: 5.57rem;
        height: 7.18rem;
      }
    }
  }
  .solution3{
    height: 10.27rem;
    .desc{
      position: absolute;
      width: 100%;
      top: .65rem;
      p{
        font-size: .18rem;
        line-height: .25rem;
        color: #666666;
        &:nth-child(1){
          font-size: .40rem;
          line-height: .56rem;
          color: black;
          margin-bottom: .17rem;
        }
      }
    }
    img{
      width: 12.96rem;
      height: 6.86rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 2.8rem;
    }
  }
  .solution4{
    height: 13.23rem;
    background-color: white;
    padding: .79rem 3.6rem;
    .title{
      color: black;
      font-size: .40rem;
      line-height: .56rem;
    }
    .title1{
      font-size: .18rem;
      color: #666;
      margin: .17rem 0 .77rem;
    }
    .prompt{
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      margin-bottom: .8rem;
      >div{
        text-align: center;
        font-size: .16rem;
        color: #999;
        line-height: .22rem;
        img{
          width: .5rem;
          height: .5rem;
        }
        &.jiyong{
          width: 2.21rem;
        }
        >div{
          text-align: left;
          &.hd{
            text-align: center;
            font-size: .20rem;
            color: #333333;
            line-height: .28rem;
            margin: .19rem 0 .08rem;
          }
        }
      }
    }
    .bg{
      width: 12rem;
      height: 7.28rem;
    }
  }
}
</style>
